import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { withRouter } from "react-router-dom";
import uuid from 'uuid/v1';
import moment from 'moment';
import  Page  from '../../components/Page';
import {  NewsFilter } from '../../components';
import { NetworkContext } from '../../context/NetworkContext';
import { SnackBarContext } from "../../context/SnackbarContext";

import { Header, Results, General } from './components';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: '100%',
    padding: theme.spacing(3)
  },
  results: {
    marginTop: theme.spacing(3)
  }
}));
export const Settings = withRouter(props => {

  const classes = useStyles();
  const [orders, setOrders] = useState([]);
  const snackbarCtx = React.useContext(SnackBarContext);
  const [profile, setProfile] = useState({});

  const [filterparams, setFilterparams] = useState({});
  const { sendNetworkRequest } = React.useContext(NetworkContext);
  const [masters, setMasters] = useState({
    commodity : []
  });
 
  async function fetchmasters()
  {
    let profileobj = await sendNetworkRequest('/admin/getemployeeprofile', {}, {id: 8},true)
    setProfile(profileobj)
   
  }
  async function fetchallnews(filtercontent = {})
  {
    let bodycontent = {
      ...filterparams,
      ...filtercontent
    }
    let newslist = await sendNetworkRequest('/fetchallnews', {}, bodycontent,false)
  
    setOrders(newslist)
  }
  async function deletenews(newsobj)
  {
    
    let commodities = await sendNetworkRequest('/deletenews', {}, {newsID : newsobj.newID},false)
    snackbarCtx.setSnack({
      ...snackbarCtx,
      open: true,
      type: "success",
      msg: commodities.message,
      vertical: "top",
    });
    fetchallnews()
   
  
  }
  function applyfilter(key,value)
  {
   
    fetchallnews({
      [key]:value
    })
    setFilterparams({
      ...filterparams,
      [key]:value
    })
  }
  useEffect(() => {
     fetchmasters()
    // fetchallnews()
    
    setOrders([{
      id: 1,
      image: "",
      title:"Update Title",
      description: "Detail Content",
      commodity:{
        name: "Edible Oil"
      },
      status : true
     }])
  }, []);

  return (
   
    <Page
      className={classes.root}
      title="Commodity"
    >
       <General userprofile={profile}/>
    
    </Page>
   
  );
});

export default Settings;
